import useIsDesktop from "@hooks/useIsDesktop"

import { Popover } from "@molecules"
import PopoverHeader from "@molecules/Popover/PopoverHeader/PopoverHeader"

import { ViewTypeMenuComponentIds } from "@organisms/ViewMenu/ViewMenu.types"

import TimelineViewMenuBottomSheet from "./TimelineViewMenuBottomSheet/TimelineViewMenuBottomSheet"
import TimelineViewMenuPopover from "./TimelineViewMenuPopover/TimelineViewMenuPopover"
import TimelineViewTimeFrameSelector from "./TimelineViewTimeFrameSelector/TimelineViewTimeFrameSelector"

export const TIMELINE_VIEW_MENU_COMPONENT_IDS: ViewTypeMenuComponentIds = {
    desktop: ["main"],
    mobile: ["main", "time-frame"],
}

export default function TimelineViewMenu() {
    const isDesktop = useIsDesktop()

    if (isDesktop) {
        return (
            <Popover.View componentId="main">
                <TimelineViewMenuPopover />
            </Popover.View>
        )
    }

    return (
        <>
            <Popover.View componentId="main">
                <TimelineViewMenuBottomSheet />
            </Popover.View>
            <Popover.View componentId="time-frame">
                <Popover.Section animationType="fade">
                    <PopoverHeader.Root>
                        <PopoverHeader.BackButton backDestination="main" aria-label="Back" />
                        <PopoverHeader.Title title="Time Frame" />
                    </PopoverHeader.Root>
                </Popover.Section>
                <Popover.Section animationType="slide">
                    <TimelineViewTimeFrameSelector.BottomSheet />
                </Popover.Section>
            </Popover.View>
        </>
    )
}
